import _ from 'lodash';
import { Literal, Null, Partial as RPartial, Runtype, Union } from 'runtypes';
import z, { ZodEnum } from 'zod';
import { util } from 'zod/v4/core';

export type Optional<T extends { [key: string]: any }> = Partial<{ [K in keyof T]: T[K] | null }>;

export const Optional = <T extends { [key: string]: Runtype<any> }>(properties: T) => {
    const mapped = _.mapValues(properties, (x) => Union(x, Null)) as {
        [K in keyof T]: Union<[T[K], Literal<null>]>;
    };
    return RPartial(mapped);
};

export function loose<T extends util.EnumLike>(type: ZodEnum<T>) {
    return type.or(z.string());
}
